// Фильтры истории карточки лида хранятся на бэке (us/11168,
// context/hooks/useLeadHistoryFilterSettings.ts); прежнее хранение в
// localStorage 'LeadCardFilters.v1' больше не читается и не пишется.

export const LEAD_CARD_CUSTOM_ACTIONS = [
  {
    label: 'Системные',
    value: 'system',
  },
  {
    label: 'Задачи',
    value: 'tasks',
  },
  {
    label: 'Лиды',
    value: 'leads',
  },
] as const;

export const normalizeId = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;

  const str = String(value).trim();
  return str.length ? str : null;
};
